// web/src/lib/displayConfig.ts — Named constants for all operational thresholds,
// display limits, and timing values used across the UI.
//
// Import from here instead of embedding magic numbers in component logic.
// ── Session / idle timeout ───────────────────────────────────────────────────
/** Idle timeout in milliseconds. User is logged out after this period of
 *  inactivity (no mouse, keyboard, scroll, or touch events).
 *  30 minutes is standard for financial applications. */
export const IDLE_TIMEOUT_MS = 30 * 60 * 1000;
/** Activity events that reset the idle timer. */
export const IDLE_ACTIVITY_EVENTS = [
    "mousemove", "mousedown", "keydown", "scroll", "touchstart", "click",
];
// ── Sophistication gating ────────────────────────────────────────────────────
/** Argus sophistication score below which advanced UI elements (eval scores,
 *  grounding badges) are hidden from novice users. Range: 0.0–1.0. */
export const SOPHISTICATION_THRESHOLD = 0.75;
// ── Confidence display ───────────────────────────────────────────────────────
/** Confidence percentile at or above which the bar renders in emerald (high). */
export const CONFIDENCE_HIGH_PCT = 80;
/** Confidence percentile at or above which the bar renders in amber (medium).
 *  Below this it renders in rose (low). */
export const CONFIDENCE_MED_PCT = 50;
// ── Execute polling ──────────────────────────────────────────────────────────
/** Maximum consecutive 5xx / network errors before the poll loop gives up. */
export const EXECUTE_POLL_MAX_RETRIES = 3;
// ── WebSocket reconnect ──────────────────────────────────────────────────────
/** Backoff delays (ms) between successive WebSocket reconnect attempts.
 *  The last value is reused if more attempts are needed. */
export const WS_RECONNECT_DELAYS_MS = [1000, 2000, 4000, 8000, 10_000];
/** WebSocket close code sent by the server when the JWT is missing or expired.
 *  Matches FastAPI status.WS_1008_POLICY_VIOLATION. On this code the client
 *  must refresh the access token before reconnecting — not retry with the
 *  stale token. */
export const WS_CLOSE_AUTH_FAILURE = 1008;
/** How long (ms) to keep a completed pipeline step buffer after the task
 *  finishes, before cleaning it up from memory. */
export const WS_STEP_BUFFER_TTL_MS = 30_000;
// ── Session display ──────────────────────────────────────────────────────────
// ── Interactive card / profile tour ─────────────────────────────────────────
/** Profile completeness score [0,1] above which the nudge banner is hidden. */
export const PROFILE_COMPLETE_THRESHOLD = 0.75;
/** Hours before a dismissed profile nudge reappears. */
export const PROFILE_NUDGE_COOLDOWN_HOURS = 24;
// ── Session display ──────────────────────────────────────────────────────────
/** Human-readable duration of the short-term memory (STM) session window.
 *  Must match TTL_STM in core/redis_client.py. */
export const STM_DISPLAY_DURATION = "2h";
